import {useIntl} from 'react-intl'
import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {getUserById, updateUser} from '../../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useFormik} from 'formik'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../ToastMetods'
import * as Yup from 'yup'
import UserDeletionModal from './Modals/UserManagementModals/UserDeletionModal'
import TabContentTableUserRole from './TabContentTables/TabContentTableUserRole'
import TabContentTableUserUnit from './TabContentTables/TabContentTableUserUnit'
import UserTabContentBar from './TabContentBars/UserTabContentBar'

const profileDetailsSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required').max(100, 'Maximum 100 character'),
  lastName: Yup.string().required('Last name is required').max(100, 'Maximum 100 character'),
  email: Yup.string()
    .email('Wrong email format')
    .min(0, 'Minimum 0 symbols')
    .max(250, 'Maximum 250 symbols')
    .required('Email is required'),
  /*
  password: Yup.string()
    .min(8, 'Minimum 8 symbols')
    .max(15, 'Maximum 15 symbols')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[\d]/, 'Password requires a numeric expression')
    .matches(/[#?!@$%^&*-./]/, 'Password requires one special character')
    .required('Password is required'),*/
})

function SelectedUser() {
  const intl = useIntl()
  const navigate = useNavigate()
  const {state}: any = useLocation()
  const page = state?.page || 1
  const rowsPerPage = state?.rowsPerPage || 5
  const userList = state?.userList || []

  const [data, setData] = useState<any>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [isChecked, setISChecked] = useState<Array<number>>([])
  const [isChecked2, setISChecked2] = useState<Array<number>>([])
  const [editData, setEditData] = useState([])
  const [action, setAction] = useState(false)

  // Get User Data
  const getList = async () => {
    try {
      const {data} = await getUserById(state?.row.id || 0)
      setData(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
  }, [])

  const initialValues = {
    id: data?.id || 0,
    firstName: data?.firstName || '',
    lastName: data?.lastName || '',
    email: data?.email || '',
    password: data?.password || '',
    IsActivated: data?.IsActivated || true,
    telefon: data.telefon || '',
    IsActivate: data?.IsActivate || true,
    activateGuid: data?.activateGuid || '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      try {
        const {data} = await updateUser(
          values.id,
          values.firstName,
          values.lastName,
          values.email,
          values.password,
          values.IsActivated,
          values.telefon,
          values.IsActivate,
          values.activateGuid
        )

        SuccessfulNotify('Successfully updated.')
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
      }
    },
  })

  useEffect(() => {
    if (action) {
      getList()
      setISChecked([])
      setISChecked2([])
      setAction(false)
    }
  }, [action])

  function handleChecked(e: any, item: any) {
    const {checked}: any = e.target
    const {id} = item
    if (checked) {
      setISChecked([...isChecked, id])
    } else {
      setISChecked(isChecked.filter((item: any) => item !== id))
    }
  }

  function handleChecked2(e: any, item: any) {
    const {value, checked}: any = e.target
    const {unitId} = item
    if (checked) {
      setISChecked2([...isChecked2, unitId])
    } else {
      setISChecked2(isChecked2.filter((item: any) => item !== unitId))
    }
  }

  function checkedControl(id: number) {
    if (isChecked) {
      if (isChecked.includes(id)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  function checkedControl2(id: number) {
    if (isChecked2) {
      if (isChecked2.includes(id)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  return (
    <div className=' gx-xl-10 mt-lg-n16 mt-2'>
      <button
        type='button'
        className='btn btn-light mb-2 '
        onClick={() =>
          navigate(`/management/users`, {
            state: {page, rowsPerPage, data: userList},
          })
        }
      >
        ❮ {intl.formatMessage({id: 'BACK'})}
      </button>
      <form onSubmit={formik.handleSubmit} className='form'>
        {/* 👇 List User Card 👇 */}
        <div className='card card-custom mt-2'>
          <div className='col-xxl-12'>
            <div className='card card-flush p-5 mb-5'>
              <div className='mb-10 row'>
                {/* 👇 First Name 👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'USER.FIRSTNAME'})}
                  </label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder={intl.formatMessage({id: 'USER.FIRSTNAME'})}
                    {...formik.getFieldProps('firstName')}
                  />
                </div>
                {/* 👆 First Name  👆 */}
                {/* 👇 Last Name   👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'USER.LASTNAME'})}
                  </label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder={intl.formatMessage({id: 'USER.LASTNAME'})}
                    {...formik.getFieldProps('lastName')}
                  />
                </div>
                {/* 👆 Last Name  👆 */}
              </div>

              <div className='mb-10 row'>
                {/* 👇 Password 👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'USER.PASSWORD'})}
                  </label>
                  <input
                    type='password'
                    className='form-control '
                    placeholder={intl.formatMessage({id: 'USER.PASSWORD'})}
                    {...formik.getFieldProps('password')}
                  />
                </div>
                {/* 👆 Password 👆 */}
                {/* 👇 Telefon   👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>Telefon</label>
                  <input
                    type='tel'
                    className='form-control '
                    placeholder='Telefon'
                    {...formik.getFieldProps('telefon')}
                  />
                </div>
                {/* 👆 Telefon  👆 */}
              </div>

              <div className='mb-10 row'>
                {/* 👇 Email 👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'USER.EMAIL'})}
                  </label>
                  <input
                    type='email'
                    className='form-control '
                    placeholder={intl.formatMessage({id: 'USER.EMAIL'})}
                    {...formik.getFieldProps('email')}
                  />
                </div>
                {/* 👆 Email  👆 */}
                {/* 👇 CheckBoxs 👇 */}
                <div className='col d-flex flex-column justify-content-center'>
                  <label className='form-label fw-bold'>{/* */}</label>
                  <div className='row mt-3'>
                    <div className='col-auto mt-2'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          id='IsActivated'
                          type='checkbox'
                          checked={formik.getFieldProps('IsActivated').value}
                          onChange={(e) => formik.setFieldValue('IsActivated', e.target.checked)}
                        />
                        <label className='form-check-label' htmlFor='IsActivated'>
                          {intl.formatMessage({id: 'USER.ISACTIVATED'})}
                        </label>
                      </div>
                    </div>
                    <div className='col-auto mt-2'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          id='IsActive'
                          type='checkbox'
                          checked={formik.getFieldProps('IsActivate').value}
                          onChange={(e) => formik.setFieldValue('IsActivate', e.target.checked)}
                        />
                        <label className='form-check-label' htmlFor='IsActive'>
                          {intl.formatMessage({id: 'USER.ISACTIVE'})}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 👆 CheckBoxs 👆 */}
              </div>

              {/* 👇 Listing Button  👇 */}
              <div className='d-flex justify-content-end'>
                <button type='submit' className='btn btn-light-success btn-lg me-3'>
                  <i className='las la-edit fs-1' />
                  {intl.formatMessage({id: 'USER.UPDATE'})}
                </button>

                <a
                  type='button'
                  data-bs-toggle='modal'
                  data-bs-target='#deleteUserModal'
                  className='btn btn-lg me-3 btn-light-danger ms-4'
                >
                  <i className='las la-trash fs-1' />
                  {intl.formatMessage({id: 'USER.DELETE'})}
                </a>
              </div>
              {/* 👆 Listing Button   👆 */}
            </div>
          </div>
        </div>
        {/* 👆 List User Card   👆 */}
      </form>

      {/* 👇 test  👇 */}

      <div className='card card-custom shadow mt-4'>
        <div className='card-header card-header-stretch'>
          <div className='card-toolbar'>
            <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0'>
              <li className='nav-item'>
                <a className='nav-link active' data-bs-toggle='tab' href='#kt_tab_panel_user-roles'>
                  Role
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' data-bs-toggle='tab' href='#kt_tab_panel_user-units'>
                  Units
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='card-body'>
          <div className='tab-content' id='userTabContent'>
            <div className='tab-pane active' id='kt_tab_panel_user-roles' role='tabpanel'>
              <UserTabContentBar
                title='Role'
                id={state?.row.id || 0}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setAction={setAction}
                isChecked={isChecked}
              />

              <div className='separator border-3 my-10'></div>
              <TabContentTableUserRole
                id={state?.row.id || 0}
                searchTerm={searchTerm}
                checkedControl={checkedControl}
                handleChecked={handleChecked}
                setEditData={setEditData}
                action={action}
                setAction={setAction}
              />
            </div>
            <div className='tab-pane fade' id='kt_tab_panel_user-units' role='tabpanel'>
              <UserTabContentBar
                title='Unit'
                id={state?.row.id || 0}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setAction={setAction}
                isChecked={isChecked2}
              />

              <div className='separator border-3 my-10'></div>
              <TabContentTableUserUnit
                id={state?.row.id || 0}
                searchTerm={searchTerm}
                checkedControl={checkedControl2}
                handleChecked={handleChecked2}
                setEditData={setEditData}
                action={action}
                setAction={setAction}
              />
            </div>
          </div>
        </div>
      </div>

      {/* 👆 test   👆 */}

      <UserDeletionModal deleteUserID={data?.id || 0} page={page} rowsPerPage={rowsPerPage} />
    </div>
  )
}

export default SelectedUser
